import {getElements} from "./utils/getElement";

const initRepeaterFields = () => {
    const repeaterFields = getElements('.js-repeater-field')

    repeaterFields.map(repeater => {
        const addButton = repeater.querySelector('.js-repeater-add')
        const itemsWrapper = repeater.querySelector('.js-repeater-field-items')

        itemsWrapper.addEventListener('click', (event) => {
            if (event.target.closest('.js-repeater-remove-item')) {
                const removeButton = event.target.closest('.js-repeater-remove-item');
                removeItem(removeButton);
            }
        });

        addButton.addEventListener('click', () => {
            const newField = itemsWrapper.appendChild(generateNewField());
            updateCounters(itemsWrapper);

            const inputField = newField.querySelector('input');
            console.log('inputField',inputField);
            console.log('newField',newField);
            inputField.addEventListener('input', (e) => {
                const sanitized = sanitizeDomain(e.target.value);
                e.target.value = sanitized;
    
                if (!isValidDomain(sanitized)) {
                    e.target.classList.add('has-error');
                } else {
                    e.target.classList.remove('has-error');
                }
            });

        })
    })
}

const generateNewField = () => {
    const newItem = document.createElement('div');
    newItem.classList.add('c-repeater-field__item', 'js-repeater-item');
    newItem.innerHTML = `
            <div class="c-repeater-field__item__counter"></div>
            <div class="c-repeater-field__item__input">
                <span class="c-repeater-field__item__input-prefix">https://</span>
                <input type="text" placeholder="Enter domain" />
            </div>
            <div class="c-repeater-field__item__remove">
                <button class="o-link o-link--icon js-repeater-remove-item">
                    <span class="o-icon o-icon--close"></span>
                </button>
            </div>
        `;

    return newItem;
}

const updateCounters = (repeaterItemsContainer) => {
    const items = repeaterItemsContainer.querySelectorAll('.js-repeater-item');
    items.forEach((item, index) => {
        const counter = item.querySelector('.c-repeater-field__item__counter');
        counter.textContent = `Website #${index + 1}`;
    });
};

const removeItem = (button) => {
    const repeaterItem = button.closest('.js-repeater-item');
    const repeaterItemsContainer = repeaterItem.closest('.js-repeater-field-items');

    // Remove the item
    repeaterItem.remove();

    // Update counters after removing the item
    updateCounters(repeaterItemsContainer);
};

const sanitizeDomain = (url) => {
    return url
        .replace(/^https?:\/\//i, '')  // Remove protocol
        .split('/')[0]                 // Keep only domain part before any slash
        .trim();
};

const isValidDomain = (domain) => {
    const pattern = /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
    return pattern.test(domain);
};

export {initRepeaterFields}
